import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { DocumentoResult } from 'src/app/models/common/DocumentoResult';
import { IListaDocumentoTecnicoRegistrarModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/IListaDocumentoTecnicoRegistrarModel';
import { ISolicitudDocumentoTecnicoAsignarModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoAsignarModel';
import { ISolicitudDocumentoTecnicoValidarModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoValidarModel';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/ISolicitudDocumentoTecnicoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudDocumentosTecnicosService {

  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');

  constructor(private http: HttpClient) { }

  submitMultiple(modelLista: IListaDocumentoTecnicoRegistrarModel){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${modelLista.idSolicitud}/documentos-tecnicos/multiple`, modelLista);
  }

  asignardocumento(idSolicitud: number,model: ISolicitudDocumentoTecnicoAsignarModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${idSolicitud}/documentos-tecnicos`, model);
  }

  guardar(formData: FormData, codigo: string, idSolicitud: number){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${idSolicitud}/documentos-tecnicos/${codigo}/upload`, formData, {reportProgress: true, observe: 'events'});
  }

  validar(model: ISolicitudDocumentoTecnicoValidarModel){
    return this.http.post<ISolicitudDocumentoTecnicoValidarModel>(`${this.configUrl}/documentos-tecnicos/validar`, model);
  }

  downloadDocumento(codigoSolicitud: string, id: number): Observable<Blob> {
    return this.http.get(`${this.configUrl}/${codigoSolicitud}/documentos-tecnicos/${id}/download`, { responseType: 'blob' });
  }

  downloadasStringDocumento(codigoSolicitud: string, id: number): Observable<DocumentoResult> {
    return this.http.get<DocumentoResult>(`${this.configUrl}/${codigoSolicitud}/documentos-tecnicos/${id}/downloadbase64`);
  }

  eliminar(idSolicitudDocumentoTecnico: number){
    return this.http.delete<ActionResultModel>(`${this.configUrl}/documentos-tecnicos/${idSolicitudDocumentoTecnico}`);
  }
}
